"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _QuerySelectingSidebar = _interopRequireDefault(require("./QuerySelectingSidebar.js"));

var _CreateQueryObjects = require("./CreateQueryObjects.js");

var _PropTypes = require("./PropTypes.js");

var _reactRouterDom = require("react-router-dom");

var _expressionAtlasHeatmapHighcharts = _interopRequireDefault(require("@ebi-gene-expression-group/expression-atlas-heatmap-highcharts"));

var _urijs = _interopRequireDefault(require("urijs"));

var _qs = _interopRequireDefault(require("qs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Main = function Main(props) {
  var queryObjects = (0, _CreateQueryObjects.fromConfigAndQuery)(props, props.query);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "row expanded column margin-top-large"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "small-3 medium-2 columns padding-left-none",
    style: {
      overflowX: "hidden"
    }
  }, /*#__PURE__*/_react["default"].createElement(_QuerySelectingSidebar["default"], {
    isDifferential: props.isDifferential,
    geneSuggesterUri: (0, _urijs["default"])("json/suggestions", props.atlasUrl).addSearch(props.species ? {
      species: props.species
    } : {}),
    genesDistributedByCutoffUrl: props.isDifferential ? "" : (0, _urijs["default"])(props.genesDistributedByCutoffUrl, props.atlasUrl).addSearch(props.isRnaSeq ? {
      unit: queryObjects.unit
    } : {}).toString(),
    loadingGifUrl: (0, _urijs["default"])("resources/images/loading.gif", props.atlasUrl).toString(),
    columnGroups: props.groups,
    defaultQuery: Object.keys(props.query).length === 0,
    availableDataUnits: props.availableDataUnits,
    queryObjects: queryObjects,
    onChangeQueryObjects: function onChangeQueryObjects(newQueryObjects) {
      props.history.push(Object.assign({}, props.location, {
        search: _qs["default"].stringify((0, _CreateQueryObjects.toQuery)(props, newQueryObjects))
      }));
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "small-9 medium-10 columns padding-right-none"
  }, /*#__PURE__*/_react["default"].createElement(_expressionAtlasHeatmapHighcharts["default"], {
    atlasUrl: props.atlasUrl,
    isWidget: false,
    isMultiExperiment: false,
    isDifferential: props.isDifferential,
    experiment: props.experimentAccession,
    query: Object.assign(props.accessKey ? {
      accessKey: props.accessKey
    } : {}, (props.isDifferential ? _CreateQueryObjects.toDifferentialRequestPreferences : _CreateQueryObjects.toBaselineRequestPreferences)(queryObjects))
  })));
};

Main.propTypes = {
  experimentAccession: _propTypes["default"].string.isRequired,
  accessKey: _propTypes["default"].string,
  isDifferential: _propTypes["default"].bool.isRequired,
  isProteomics: _propTypes["default"].bool.isRequired,
  isRnaSeq: _propTypes["default"].bool.isRequired,
  atlasUrl: _propTypes["default"].string.isRequired,
  species: _propTypes["default"].string.isRequired,
  groups: _propTypes["default"].arrayOf(_propTypes["default"].shape(_PropTypes.InitialColumnGroupPropTypes)).isRequired,
  genesDistributedByCutoffUrl: _propTypes["default"].string.isRequired,
  availableDataUnits: _propTypes["default"].arrayOf(_propTypes["default"].string.isRequired).isRequired,
  query: _propTypes["default"].shape(_PropTypes.QueryPropTypes).isRequired,
  history: _propTypes["default"].object.isRequired,
  location: _propTypes["default"].object.isRequired
};

var _default = (0, _reactRouterDom.withRouter)(Main);

exports["default"] = _default;